import { useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/store';
import InventoryBody from './InventoryBody';
import { userSlice } from '../../store/reducers/userReducer';
import ImgWithFallback from '../ui/ImgWithFallback';
import './Inventory.scss'

import coins from '../../assets/img/inventory/Icons_01.png'
import coinsWebp from '../../assets/img/inventory/Icons_01.webp'
import goldIcon from '../../assets/img/inventory/coin2.png'
import goldIconWebp from '../../assets/img/inventory/coin2.webp'
import bagPack from '../../assets/img/inventory/Backpack1.png'
import bagPackWebp from '../../assets/img/inventory/Backpack1.webp'

interface IInventoryProps {
    closeInventory?: () => void
    setPlayerHp?: React.Dispatch<React.SetStateAction<number>>
    classIfCharWindowOpen?: string
    isOpenInShop?: boolean
}

const Inventory = ({ closeInventory, setPlayerHp, classIfCharWindowOpen, isOpenInShop }: IInventoryProps) => {

    const dispatch = useAppDispatch()
    const mainCharacter = useAppSelector(state => state.userReducer.character)
    const showCurrensy = useAppSelector(state => state.userReducer.showCurrensy)
    const { switchInventory } = userSlice.actions
    const isBuyOrSellItem = useAppSelector(state => state.userReducer.isBuyOrSellItem)

    const handleSwitchInventory = () => {
        dispatch(switchInventory(!showCurrensy))
    }

    const headerText = showCurrensy ? 'Currensy' : 'Inventory'
    const classOpenInShop = isOpenInShop ? 'inShop' : ''

    const inventoryClose = !isOpenInShop ?
        (<span className='inventory__close' onClick={closeInventory}></span>) : ''

    const inventoryHeader = !isOpenInShop ?
        (<h1 className="inventory__title">{headerText}</h1>)
        :
        (<div className='inventory__header'>
            <ImgWithFallback
                src={mainCharacter.getImgSmall().webp}
                fallbackSrc={mainCharacter.getImgSmall().img} />
            <h2 className="inventory__header-title">{headerText}</h2>
        </div>)

    const userCharacterGold = useMemo(() => {
        return mainCharacter.getGold()
    }, [isBuyOrSellItem])

    return (
        <div className={`inventory ${classIfCharWindowOpen} ${classOpenInShop}`}>
            <div className={`inventory__wrapper ${classIfCharWindowOpen}`} >
                <div className="inventory__container">
                    {inventoryHeader}
                    {inventoryClose}
                    <div className="inventory__body">
                        <InventoryBody setPlayerHp={setPlayerHp} />
                    </div>
                    <div className="inventory__footer">
                        <div
                            className="inventory__footer-switch adaptive-img-cover"
                            onClick={handleSwitchInventory}
                        >
                            {showCurrensy ?
                                <ImgWithFallback src={bagPackWebp} fallbackSrc={bagPack} />
                                :
                                <ImgWithFallback src={coinsWebp} fallbackSrc={coins} />
                            }
                        </div>
                        <div className='inventory__footer-gold'>
                            <div className='adaptive-img-cover'>
                                <ImgWithFallback src={goldIconWebp} fallbackSrc={goldIcon} />
                            </div>
                            <span>{userCharacterGold}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Inventory;